// 'use client';
// import dynamic from 'next/dynamic';
import React, { Fragment } from 'react';
import ContentLoader from 'react-content-loader';
// const ContentLoader = dynamic(() => import('react-content-loader'), { ssr: false });
import * as Styled from './styled';

const RepositoryFolderLoader: React.FC<{ rows?: number; rowHeight?: number; padding?: number }> = ({
  rows = 10,
  rowHeight = 20,
  padding = 12,
  ...rest
}) => {
  const paddedRowHeight = rowHeight + padding * 2;

  return (
    <Styled.Loader>
      <ContentLoader
        uniqueKey="repository-folder-content-loader"
        viewBox={`0 0 1280 ${paddedRowHeight * rows}`}
        {...rest}
      >
        {new Array(rows).fill(' ').map((el, index) => {
          const contentVerticalPosition = (contentHeight: number) =>
            rows > 1 ? contentHeight + paddedRowHeight * index : contentHeight;
          // const contentWidth = Math.random() * 200 + 100;
          const contentWidth = 200;
          return (
            <Fragment key={index}>
              <rect x="15" y={`${contentVerticalPosition(padding)}`} rx="5" ry="6" width="15" height={rowHeight} />
              <rect
                x="40"
                y={`${contentVerticalPosition(padding)}`}
                rx="5"
                ry="6"
                width={contentWidth}
                height={rowHeight}
              />
              <rect x="400" y={`${contentVerticalPosition(padding)}`} rx="5" ry="6" width="40" height={rowHeight} />
              <rect x="500" y={`${contentVerticalPosition(padding)}`} rx="5" ry="6" width="200" height={rowHeight} />
              <rect x="1000" y={`${contentVerticalPosition(padding)}`} rx="5" ry="6" width="50" height={rowHeight} />
              <rect x="1200" y={`${contentVerticalPosition(padding)}`} rx="5" ry="6" width="70" height={rowHeight} />
              {index < rows - 1 && (
                <rect y={`${contentVerticalPosition(paddedRowHeight)}`} x="0" ry="10" width="1280" height="1" />
              )}
            </Fragment>
          );
        })}
      </ContentLoader>
    </Styled.Loader>
  );
};

export default RepositoryFolderLoader;
